import React, { useEffect, useRef } from "react";
import { awards } from "../mock/extra";
import { Award, Trophy, Medal, BadgeCheck } from "lucide-react";

const icons = [Award, Trophy, Medal, BadgeCheck];

export default function Awards() {
  const trackRef = useRef(null);

  // Auto-scroll marquee for awards
  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    let raf; let x = 0;
    const step = () => {
      x -= 0.6;
      if (Math.abs(x) >= el.scrollWidth / 2) x = 0;
      el.style.transform = `translateX(${x}px)`;
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, []);

  const items = [...awards, ...awards];

  return (
    <section id="awards" className="py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-6">
            <div className="section-eyebrow">Awards &amp; Honours</div>
            <h2 className="mt-4 font-serif-display text-[42px] md:text-[62px] leading-[1.05] text-[#0e2b2b]">
              Recognised for <span className="hero-italic">excellence</span><br />in modern dentistry
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-[15px] md:text-[16px] text-[#0e2b2b]/70 leading-relaxed max-w-[520px]">
              Our doctors have been recognised across India and internationally for painless implantology, digital smile design and patient‑first care. Every award is a promise we bring back to the chairside.
            </p>
          </div>
        </div>

        {/* Marquee track */}
        <div className="mt-14 relative overflow-hidden">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
          <div ref={trackRef} className="flex gap-5 w-max will-change-transform">
            {items.map((a, i) => {
              const Icon = icons[i % icons.length];
              return (
                <div key={i} className="w-[300px] shrink-0 bg-[#f6f7f4] rounded-3xl p-6 border border-[#0e2b2b]/10 card-lift">
                  <div className="flex items-center justify-between gap-2">
                    <span className="w-12 h-12 rounded-2xl bg-white border border-[#0e2b2b]/10 flex items-center justify-center text-[#14a68e] shrink-0"><Icon className="w-6 h-6" /></span>
                    <span className={`font-serif-display text-[#0e2b2b]/70 leading-none text-right ${a.year.length > 4 ? "text-[16px]" : "text-[28px]"}`}>{a.year}</span>
                  </div>
                  <h4 className="mt-5 font-serif-display text-[19px] text-[#0e2b2b] leading-tight">{a.title}</h4>
                  <p className="mt-2 text-[12px] tracking-[0.18em] uppercase text-[#14a68e] font-semibold">{a.org}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Featured accreditations strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { t: "IDA", s: "Life Member" },
            { t: "IFAD", s: "Life Member" },
            { t: "ISP", s: "Life Member" },
            { t: "AOI", s: "Life Member" },
          ].map((x) => (
            <div key={x.t} className="bg-[#f6f7f4] border border-[#0e2b2b]/10 rounded-2xl px-5 py-4 text-center">
              <div className="font-serif-display text-[20px] text-[#0e2b2b] leading-tight">{x.t}</div>
              <div className="text-[11px] tracking-[0.18em] uppercase text-[#14a68e] font-semibold mt-1">{x.s}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
